module.exports = __webpack_public_path__ + "img/location2.60b25ff2.png";